import React from 'react'
import {connect} from 'react-redux'
import * as reportActions from 'lib/api/rideReports'
import {CircleSpinner} from 'common/spinners'
import {Button} from 'common/Button'
import {Link} from 'react-router'
import reportListStyles from '../../IndexPage/ReportList/ReportList.scss'
// TODO move to common/ReportCard 👍
import {ReportCard} from '../../IndexPage/ReportCard'
import styles from './ShowPage.scss'
import appStyles from '../../App/appStyles.scss'

export class ShowPage extends React.Component {
  ensureReportsLoaded () {
    const {reports, reportsPage, loadUserReports} = this.props
    if (reports || !reportsPage.user) return
    loadUserReports(reportsPage.user.id)
  }

  componentDidMount () {
    this.ensureReportsLoaded()
  }

  componentDidUpdate () {
    this.ensureReportsLoaded()
  }

  render () {
    const {reportsPage: {id, title, subtitle, followersCount, user}, reports, currentUser} = this.props

    if (!id) {
      return (
        <CircleSpinner size={50} />
      )
    }

    const pageTitle = title || `Reports by ${user.name}`
    const canEdit = currentUser.id === user.id

    return (
      <div className={styles.ShowPage}>
        <h1 className={appStyles.pageTitle}>{pageTitle}</h1>
        <div className={styles.belowTitle}>
          {subtitle &&
          <p className={styles.reportsPageSubtitle}>{subtitle}</p>}
          {canEdit &&
          <div>
            <Button className={styles.editButton} type='default'><Link to={`/reports_pages/${id}/edit`}>Edit title & description</Link></Button>
          </div>}
        </div>
        {followersCount > 0 &&
        <p>{followersCount} follower{followersCount > 1 && 's'}</p>}
        <div className={reportListStyles.reportsContainer}>
          {reports && reports.map(r => <ReportCard report={r} key={r.id} currentUser={currentUser} />)}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {rideReports: {reports, topics}, reportsPage} = state
  const topic = reportsPage.user && topics.get(`user-${reportsPage.user.id}`)
  return {
    reports: topic && topic.reportIds && topic.reportIds.map(id => reports.get(id)),
    reportsPage: state.reportsPage,
    currentUser: state.currentUser
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadUserReports: id => dispatch(reportActions.loadUserReports(id))
})

export const ShowPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ShowPage)
